module.exports = __webpack_public_path__ + "img/SKWINKELNetActieSuggestiesCA526C.05767d96.png";